import { GridImageItem, GridTextItem } from '@zola/zola-ui/src/components/PreAuthV3/Grid';
import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import * as BREAKPOINTS from '@zola/zola-ui/src/lib/ui/breakpoints';

import CoupleViewingAlbumDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/CoupleViewingAlbum.jpg';
import HoldingAlbumDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/HoldingAlbum.jpg';
import HowToBackgroundDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/HowToBackground.jpg';
import HowToForegroundDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/HowToForeground.png';
import MultipleAlbumsDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/MultipleAlbums.jpg';
import PhotographicBackgroundDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/PhotographicBackground.jpg';
import PhotographicForegroundDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/PhotographicForeground.png';
import SingleAlbumDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/SingleAlbum.jpg';

import CoupleViewingAlbumDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/CoupleViewingAlbum.webp';
import HoldingAlbumDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/HoldingAlbum.webp';
import HowToBackgroundDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/HowToBackground.webp';
import MultipleAlbumsDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/MultipleAlbums.webp';
import PhotographicBackgroundDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/PhotographicBackground.webp';
import SingleAlbumDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/desktop/SingleAlbum.webp';

import HowToBackgroundMobile from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/HowToBackground.jpg';
import HowToForegroundMobile from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/HowToForeground.png';
import MultipleAlbumsMobile from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/MultipleAlbums.jpg';
import PhotographicBackgroundMobile from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/PhotographicBackground.jpg';
import PhotographicForegroundMobile from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/PhotographicForeground.png';

import HowToBackgroundMobileWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/HowToBackground.webp';
import MultipleAlbumsMobileWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/MultipleAlbums.webp';
import PhotographicBackgroundMobileWebp from '../../../../../public/static-preauth/images/WeddingAlbums/grid/mobile/PhotographicBackground.webp';

const gridTitles = [
  { highlightText: 'Easy to make,', titleEnd: 'made to last' },
  { highlightText: 'High quality prints,', titleEnd: 'premium materials' },
  { highlightText: 'Need design help?', titleEnd: 'Our experts are here for you' },
];

const getGridTextItem = (titleIndex: number): GridTextItem => {
  return {
    highlightTitle: {
      ...gridTitles[titleIndex],
      isH1: false,
    },
    linkText: 'Start your album',
    href: '/wedding-albums/select?album_type=premier',
  };
};

const photographicImage: GridImageItem = {
  image: {
    background: {
      parameters: {
        alt: '',
        featuredSrc: PhotographicBackgroundDesktop,
        jpg: [
          {
            breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
            url: PhotographicBackgroundDesktop,
          },
          {
            breakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString(),
            url: PhotographicBackgroundMobile,
          },
        ],
        webp: [
          {
            breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
            url: PhotographicBackgroundDesktopWebp,
          },
          {
            breakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString(),
            url: PhotographicBackgroundMobileWebp,
          },
        ],
      },
      type: BackgroundType.IMAGE,
    },
    foregroundImage: {
      desktopSrc: PhotographicForegroundDesktop,
      imgType: 'png',
      mobileSrc: PhotographicForegroundMobile,
      tabletSrc: PhotographicForegroundMobile,
    },
  },
};

const multipleAlbumsImage: GridImageItem = {
  image: {
    background: {
      parameters: {
        alt: '',
        featuredSrc: MultipleAlbumsDesktop,
        jpg: [
          {
            breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
            url: MultipleAlbumsDesktop,
          },
          {
            breakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString(),
            url: MultipleAlbumsMobile,
          },
        ],
        webp: [
          {
            breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
            url: MultipleAlbumsDesktopWebp,
          },
          {
            breakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString(),
            url: MultipleAlbumsMobileWebp,
          },
        ],
      },
      type: BackgroundType.IMAGE,
    },
  },
};

const howToImage: GridImageItem = {
  image: {
    background: {
      parameters: {
        alt: '',
        featuredSrc: HowToBackgroundDesktop,
        jpg: [
          {
            breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
            url: HowToBackgroundDesktop,
          },
          {
            breakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString(),
            url: HowToBackgroundMobile,
          },
        ],
        webp: [
          {
            breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
            url: HowToBackgroundDesktopWebp,
          },
          {
            breakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString(),
            url: HowToBackgroundMobileWebp,
          },
        ],
      },
      type: BackgroundType.IMAGE,
    },
    foregroundImage: {
      desktopSrc: HowToForegroundDesktop,
      imgType: 'png',
      mobileSrc: HowToForegroundMobile,
      tabletSrc: HowToForegroundMobile,
    },
  },
};

export const desktopGridItems: (GridImageItem | GridTextItem)[] = [
  getGridTextItem(0),
  {
    image: {
      background: {
        parameters: {
          alt: '',
          featuredSrc: CoupleViewingAlbumDesktop,
          jpg: [
            {
              breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
              url: CoupleViewingAlbumDesktop,
            },
          ],
          webp: [
            {
              breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
              url: CoupleViewingAlbumDesktopWebp,
            },
          ],
        },
        type: BackgroundType.IMAGE,
      },
    },
  },
  {
    image: {
      background: {
        parameters: {
          alt: '',
          featuredSrc: HoldingAlbumDesktop,
          jpg: [
            {
              breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
              url: HoldingAlbumDesktop,
            },
          ],
          webp: [
            {
              breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
              url: HoldingAlbumDesktopWebp,
            },
          ],
        },
        type: BackgroundType.IMAGE,
      },
    },
  },
  multipleAlbumsImage,
  photographicImage,
  getGridTextItem(1),
  getGridTextItem(2),
  {
    image: {
      background: {
        parameters: {
          alt: '',
          featuredSrc: SingleAlbumDesktop,
          jpg: [
            {
              breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
              url: SingleAlbumDesktop,
            },
          ],
          webp: [
            {
              breakpoint: BREAKPOINTS.SCREEN_MD_MAX.toString(),
              url: SingleAlbumDesktopWebp,
            },
          ],
        },
        type: BackgroundType.IMAGE,
      },
    },
  },
  howToImage,
];

export const mobileGridItems: (GridImageItem | GridTextItem)[] = [
  getGridTextItem(0),
  multipleAlbumsImage,
  photographicImage,
  getGridTextItem(1),
  getGridTextItem(2),
  howToImage,
];
